export default __webpack_public_path__ + "static/media/LadderAnnotations.551dcabf.png";